module.exports = __webpack_public_path__ + "static/exterior-3-a437935ef77ea8ecd5028fa037f75beb.jpg";